import * as zod from "zod";

export const FolderZod = zod.enum([
    "productImages",
    "productImagesEnhanced",
    "productReviewImages",
    "vaultFiles",
    "font",
    "svg",
    "entityContent",
    "static/image",
    "bookingQuestion",
    "systemTag",
]);
export type Folder = zod.infer<typeof FolderZod>;
